// 角色权限：后端是最终判断，这里只负责把没权限的按钮藏起来
// FINANCE 财务：全部；FRONT_DESK 前台：查询 + 录入；BOSS 老板/股东：只查询
export function currentRole() {
  try {
    const user = JSON.parse(localStorage.getItem('userdata') || '{}')
    return user.role || 'BOSS'
  } catch (e) {
    return 'BOSS'
  }
}

export function canEntry() {
  const role = currentRole()
  return role === 'FINANCE' || role === 'FRONT_DESK'
}

export function canManage() {
  return currentRole() === 'FINANCE'
}

export default {
  install(Vue) {
    Vue.prototype.$canEntry = canEntry
    Vue.prototype.$canManage = canManage
  }
}



// WEBPACK FOOTER //
// ./src/utils/permission.js